import { useTranslation } from 'react-i18next'

import { ClipboardTextIcon } from '@phosphor-icons/react'

import { Button, Checkbox, PackageCheckIcon, TrolleyIcon } from '@reveni-io/reveni-ui'

import { userPermissions } from '@/common/constants'
import useUserPermissions from '@/common/hooks/useUserPermissions/useUserPermissions'

import * as Styles from './styles'

const SelectAll = ({
  selectedParcels,
  parcels,
  onSelectAll,
  onPrepare,
  onGeneratePackingList,
  onGeneratePickingList,
  preparableParcels,
  packableParcels,
  pickableParcels,
}) => {
  const { t } = useTranslation()
  const { hasPermission } = useUserPermissions()

  const getSelectedLabel = () => {
    if (!parcels?.length) {
      return `0 ${t('envíos seleccionables')}`
    }

    if (selectedParcels?.length === 1) {
      return `${selectedParcels?.length} ${t('envío seleccionado')}`
    }
    return `${selectedParcels?.length} ${t('envíos seleccionados')}`
  }

  const getButtonLabel = () => {
    if (preparableParcels?.length === 1) {
      return `${t('Preparar')} ${preparableParcels?.length} ${t('envío')}`
    }
    return `${t('Preparar')} ${preparableParcels?.length} ${t('envíos')}`
  }

  const isChecked = () => selectedParcels?.length > 0 && selectedParcels?.length === parcels?.length

  const isIndeterminate = () => selectedParcels?.length > 0 && selectedParcels?.length < parcels?.length

  return (
    <Styles.Container>
      <Checkbox
        checked={isChecked()}
        onChange={onSelectAll}
        indeterminate={isIndeterminate()}
        label={getSelectedLabel()}
        disabled={!parcels?.length}
      />
      {hasPermission(userPermissions.prepareShipment) && selectedParcels?.length > 0 && (
        <Styles.Actions>
          {preparableParcels?.length > 0 && (
            <Button size="s" onClick={onPrepare} variant="outlined">
              <PackageCheckIcon size={16} /> {getButtonLabel()}
            </Button>
          )}
          {packableParcels?.length > 0 && (
            <Button size="s" onClick={onGeneratePackingList} variant="outlined">
              <ClipboardTextIcon size={16} /> {t('Generar lista empaquetado')}
            </Button>
          )}
          {pickableParcels?.length > 0 && (
            <Button size="s" onClick={onGeneratePickingList} variant="outlined">
              <TrolleyIcon size={16} /> {t('Generar lista de recogida')}
            </Button>
          )}
        </Styles.Actions>
      )}
    </Styles.Container>
  )
}

export default SelectAll
